import { openModal } from '../../../../actions/modal.action';

// Attribute questions are edited from Other Filters, never from the question
// editor.
const AttributeQuestionDialog = (dispatch) => {
  openModal({
    className: 'modal-alert-width',
    button1Text: 'Close',
    button1Action: 'closeModal',
    imageSrc: '/icons/triangle.png',
    body: 'This question is an attribute filter. Edit it from Other Filters.',
  })(dispatch);
};

export default AttributeQuestionDialog;
